import { render, staticRenderFns } from "./BreakInDamagesQuestion.vue?vue&type=template&id=031a0e36&scoped=true"
import script from "./BreakInDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./BreakInDamagesQuestion.vue?vue&type=script&lang=ts"
import style0 from "./BreakInDamagesQuestion.vue?vue&type=style&index=0&id=031a0e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a0e36",
  null
  
)

export default component.exports